export default __webpack_public_path__ + "static/media/fad-modsh.7a19373d.svg";